import styles from './default-email-header.module.scss'
import { Typography } from '@/ui-kit'
import { useTranslation } from 'react-i18next'

interface Props {
    titleKey?: string
    subtitleKey?: string
}

export const DefaultEmailHeader: React.FC<Props> = ({
    titleKey = 'auth.title',
    subtitleKey = 'auth.subtitle'
}) => {
    const { t } = useTranslation()

    return (
        <>
            <Typography
                variant="p"
                fontWeight="medium"
                className={styles.titleForm}
                center>
                {t(titleKey)}
            </Typography>
            <Typography
                variant="p"
                fontWeight="medium"
                className={styles.subtitleForm}
                center>
                {t(subtitleKey)}
            </Typography>
        </>
    )
}
